import { captureReactException } from '@sentry/react';
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { FallbackScreen } from './FallbackScreen';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Envia para o Sentry junto com o componentStack, que é o que diz QUAL
    // componente quebrou. Sem VITE_SENTRY_DSN configurada, é no-op.
    captureReactException(error, errorInfo);
    // eslint-disable-next-line no-console
    console.error('Erro não tratado capturado pelo ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <FallbackScreen onReload={() => window.location.reload()} />;
    }

    return this.props.children;
  }
}
